import {mainQuery} from '@github-ui/react-core/future/main-query'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {reposPulseAppBuilder} from '../config/app-builder'

export type PulseResponse = {
  committerDataPath: string
  diffstatSummaryPath: string
  overviewDataPath: string
}

const useExistingUrl = isFeatureEnabled('override_pulse_legacy_url')

export const pulseRoute = reposPulseAppBuilder.createQueryRouteConfig('pulseRoute', {
  path: useExistingUrl ? '/:owner/:repo/pulse' : '/:owner/:repo/pulse-new',
  queries: [mainQuery<PulseResponse>()],
})
